import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '../useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api';
import { jobPipelineEndpoints } from '@/lib/api/endpoints';
import { jobPipelineKeys } from '@/lib/queryKeys';
import type { PipelineStage, UpdateStageDto } from '@/types/pipeline';

export function useUpdateStage() {
  const qc = useQueryClient();
  return useApiMutation<PipelineStage, UpdateStageDto & { pipelineId: string; stageId: string }>({
    mutationFn: ({ pipelineId, stageId, ...dto }) =>
      apiPatch<PipelineStage, UpdateStageDto>(
        operationsClient,
        jobPipelineEndpoints.stage(pipelineId, stageId),
        dto,
      ),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: jobPipelineKeys.detail(vars.pipelineId) });
      void qc.invalidateQueries({ queryKey: jobPipelineKeys.lists() });
    },
    showErrorToast: true,
  });
}
